import React from 'react';
import {Route, Routes as DefaultAppRoutes} from 'react-router-dom';
import Adminlogin from './pages/Adminlogin';
import OrgSignIn from './pages/OrgSignIn';
import Unauthorized from './pages/Unauthorized';

const DefaultRoutes=()=>{
return(
<div>
<DefaultAppRoutes>
<Route path='/' element={<OrgSignIn />} />
 <Route path='/adminlogin' element={<Adminlogin />} />
<Route path='/newadmin' element={<OrgSignIn />} />
<Route path='*' element={<Unauthorized />} />
</DefaultAppRoutes>
</div>
)}

export default DefaultRoutes;

